// Placeholder for the conversational-assistance surface. The real chat UI
// + AI Gateway wiring lands with ADV-803 (Story 5.3 — shared chat backend).
// Linking to this route from the ⌘K palette today gives the entry a real
// destination instead of dead-ending; when ADV-803 ships, this file becomes
// the chat surface and the palette action's `run` flips to opening the chat
// affordance directly (single one-line change in lib/actions.ts).

import { EmptyState } from "@/components/v2/empty-state";
import { ListPage } from "@/components/v2/list-page";

export default function V2AskAdvaPage() {
  return (
    <ListPage title="Ask Adva">
      <EmptyState
        title="Ask Adva is coming soon"
        description="Conversational assistance lands with the unified chat backend."
      />
    </ListPage>
  );
}
